export default [
  {
    id: '2-1',
    parentId: '0',
    title: '投放计划',
    path: '/brands/plan-list',
    type: 2,
    component: '/brands/plan/plan-list/plan-list',
    isHidden: false,
    icon: 'kl-plan'
  },
  {
    id: '2-2',
    parentId: '0',
    title: '投放详情',
    path: '/brands/plan-module',
    type: 2,
    component: '/brands/plan/plan-module/plan-module',
    isHidden: true,
    icon: 'kl-plan'
  },

  {
    id: '2-3',
    parentId: '0',
    title: '投放管理',
    path: '/brands/plan-manage',
    type: 2,
    component: '/brands/plan/plan-manage/plan-manage',
    isHidden: true,
    icon: 'kl-plan'
  },

  // child 子页
  {
    id: '2-4-1',
    parentId: '0',
    title: '投放计划-编辑',
    path: '/brands/plan-expert-put-edit',
    type: 2,
    component: '/brands/plan/all-c-pages/plan-expert-put-add-or-edit/plan-expert-put-add-or-edit',
    isHidden: true,
    icon: 'kl-plan'
  },

  {
    id: '2-4-2',
    parentId: '0',
    title: '投放计划-详情',
    path: '/brands/plan-expert-put-detail',
    type: 2,
    component: '/brands/plan/all-c-pages/plan-expert-put-detail/plan-expert-put-detail',
    isHidden: true,
    icon: 'kl-plan'
  }
]
